import { render, staticRenderFns } from "./ImageHolderModal.vue?vue&type=template&id=b00d1dde&scoped=true&"
import script from "./image-holder-modal.ts?vue&type=script&lang=ts&"
export * from "./image-holder-modal.ts?vue&type=script&lang=ts&"
import style0 from "./image-holder-modal.scss?vue&type=style&index=0&id=b00d1dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00d1dde",
  null
  
)

export default component.exports